const state = {
  sex: '',
  city: ''
};
const mutations = {
  settingSex(state, payload) {
    state.sex = payload;
  },
  settingCity(state, payload) {
    state.city = payload;
  }
};
export default {
  namespaced: true,
  state,
  mutations
};
